import { Hammer } from 'lucide-react';
import { PageHeader } from '@/components/ui/Card.js';

/**
 * Hali qurilmagan bo'lim.
 *
 * Menyudan olib tashlash o'rniga ochiq qoldirilgan: shunda tuzilma
 * boshidanoq ko'rinib turadi va mijoz nima qolganini biladi.
 */
export function StagePlaceholder({ title, stage }: { title: string; stage: 'B7' | 'B8' }) {
  const description =
    stage === 'B7'
      ? 'Kontent bo‘limlari va blok konstruktori B7 bosqichida qo‘shiladi.'
      : 'Do‘kon va narxlar boshqaruvi B8 bosqichida qo‘shiladi.';

  return (
    <>
      <PageHeader title={title} />
      <div className="flex flex-col items-center gap-3 border border-dashed border-n-200 bg-white px-6 py-16 text-center">
        <Hammer className="size-8 text-n-200" aria-hidden />
        <p className="font-medium text-n-800">Bo‘lim tayyorlanmoqda</p>
        <p className="max-w-md text-sm text-n-600">{description}</p>
        <p className="text-xs text-n-400">API tayyor — interfeys ustida ish ketmoqda ({stage}).</p>
      </div>
    </>
  );
}
